<script>
   /****************************************************************
   * SensitivityPlot                                               *
   * --------------------                                          *
   * shows plot with sensitivity values vs. number of PCs          *
   *****************************************************************/

   import { PNG_WIDTH, PNG_HEIGHT, PNG_RES } from './Defaults.js';
   import StatCompPlot from './StatCompPlot.svelte';
   import StatCompConfidenceArea from './StatCompConfidenceArea.svelte';

   export let params;                     // JSON with main plot parameters
   export let res;                        // JSON with SIMCA results
   export let ncomp = 1;                  // number of components selected by user

   export let fileName = 'plot-sensitivity';
   export let pngWidth = PNG_WIDTH;
   export let pngHeight = PNG_HEIGHT;
   export let pngRes = PNG_RES;


   /*****************************************/
   /* Component code                        */
   /*****************************************/

   // constant plot parameters
   const xLabel = 'Number of PCs';
   const yLabel = 'Sensitivity';
   const title = 'Sensitivity plot';

   // parameters depending on the provided results
   let alpha, nObj, ciTop, ciBottom, ciMargin, nCompMax;
   $: if (res) {
      const resobj = res[Object.keys(res)[0]]
      nObj = resobj.nrows;
      alpha = resobj.alpha;
      nCompMax = resobj.v.length;
   } else {
      alpha = null;
      nCompMax = 1;
   }

   // reactive computation of y limits
   $: limYMin = params && params.zoom === 'on' ? ciBottom - 0.5 * ciMargin : -0.1;
   $: limYMax = params && params.zoom === 'on' ? ciTop + 0.5 * ciMargin : 1.2;
</script>

{#if res }
<StatCompPlot
   {res} {ncomp} {params} {limYMax} {limYMin}
   {title} {xLabel} {yLabel} {fileName}
   {pngWidth} {pngHeight} {pngRes}
   statName='sensitivity'
>

   <!-- area with possible sensitivity -->
   <StatCompConfidenceArea
      slot="before" {alpha} {nCompMax} {nObj}
      bind:ciMargin={ciMargin}
      bind:ciTop={ciTop}
      bind:ciBottom={ciBottom}
   />

</StatCompPlot>
{/if}